import request from '@/utils/request'

// 查询H5小程序列表
export function listH5Applet(query) {
  return request({
    url: '/system/h5Applet/list',
    method: 'get',
    params: query
  })
}

// 查询H5小程序详细
export function getH5Applet(appletId) {
  return request({
    url: '/system/h5Applet/' + appletId,
    method: 'get'
  })
}

// 新增H5小程序
export function addH5Applet(data) {
  return request({
    url: '/system/h5Applet',
    method: 'post',
    data: data
  })
}

// 修改H5小程序
export function updateH5Applet(data) {
  return request({
    url: '/system/h5Applet',
    method: 'put',
    data: data
  })
}

// 删除H5小程序
export function delH5Applet(appletId) {
  return request({
    url: '/system/h5Applet/' + appletId,
    method: 'delete'
  })
}

// 导出H5小程序
export function exportH5Applet(query) {
  return request({
    url: '/system/h5Applet/export',
    method: 'get',
    params: query
  })
}

// 导出H5小程序
// export function exportH5Applet(query) {
//   return request({
//     url: '/system/h5Applet/export',
//     method: 'get',
//     params: query
//   })
// }


// WEBPACK FOOTER //
// ./src/api/h5Applet.js